module.exports = __webpack_public_path__ + "static/img/areaA-29.e4c9b02.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA-29.png
// module id = 973
// module chunks = 1